const notifications = require('../lib/notifications');

module.exports.submitFormDataOnFormSubmission = function (form, success, unauthorized, forbidden) {

    form.onsubmit = function (event) {
        event.preventDefault();

        const formData = new FormData(form);
        const url = form.getAttribute('action');
        const submissionControl = form.querySelector('input[type=submit]');
        const notificationControl = form.getElementsByClassName('notification')[0];

        const unprocessableEntity = function (responseJson) {
            const formElements = form.elements;
            for (let i = 0; i < formElements.length; i++) {
                const formElement = formElements[i];
                const formElementName = formElement.name;
                if (formElementName in responseJson.errors) {
                    formElement.focus();
                    return responseJson.errors[formElementName].join('<br>');
                }
            }
            return genericUnprocessableEntity(responseJson);
        };

        submitFormData(formData, url, submissionControl, notificationControl, success, unauthorized || defaultUnauthorized, forbidden || defaultForbidden, unprocessableEntity);

        return false;
    }

};

module.exports.submitFormData = function (formData, url, submissionControl, notificationControl, success) {
    submitFormData(formData, url, submissionControl, notificationControl, success || emptySuccess, defaultUnauthorized, defaultForbidden, genericUnprocessableEntity)
};

function submitFormData(formData, url, submissionControl, notificationControl, success, unauthorized, forbidden, unprocessableEntity) {

    function showSuccess(successMessage) {
        if (successMessage) {
            notifications.showSuccess(successMessage, notificationControl);
        }
    }

    function showError(errorMessage) {
        if (errorMessage) {
            notifications.showFailure(errorMessage, notificationControl);
        }
    }

    submissionControl.disabled = true;

    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function () {
        submissionControl.disabled = false;
        if (xhr.status === 200) {
            showSuccess(success(xhr.responseText));
        } else if (xhr.status === 401) {
            showError(unauthorized());
        } else if (xhr.status === 403) {
            showError(forbidden());
        } else if (xhr.status === 422) {
            showError(unprocessableEntity(JSON.parse(xhr.responseText)));
        } else {
            showError('Die Aktion ist fehlgeschlagen (' + xhr.status + ')' + '.');
        }
    };
    xhr.onerror = function () {
        submissionControl.disabled = false;
        showError('Es ist ein Fehler aufgetreten (' + xhr.status + ').');
    };
    xhr.send(formData);

}

const emptySuccess = function () {
};

const defaultUnauthorized = function () {
    return 'Der Benutzer ist nicht angemeldet.';
};

const defaultForbidden = function () {
    return 'Der Benutzer verfÃ¼gt nicht Ã¼ber die erforderlichen Berechtigungen.';
};

const genericUnprocessableEntity = function (responseJson) {
    for (let error in responseJson.errors) {
        return responseJson.errors[error].join('<br>');
    }
};
